// src/components/Header.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const ADMIN_EMAIL = 'urano@hgu.jp';

export default function Header() {
  const { user, loginWithGoogle, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const isAdmin = user?.email === ADMIN_EMAIL;

  return (
    <header className="app-header">
      <div className="app-header-inner">
        <Link to="/" className="app-logo" style={{ textDecoration: 'none' }}>
          ScheduleSync <span>会議スケジュール調整</span>
        </Link>

        <div className="flex items-center gap-3">
          {user === undefined ? (
            <div className="spinner" />
          ) : user ? (
            <>
              <Link to="/create">
                <button className="btn btn-primary btn-sm">+ 新規作成</button>
              </Link>
              <div style={{ position: 'relative' }}>
                <button
                  onClick={() => setMenuOpen(v => !v)}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}
                >
                  {user.photoURL
                    ? <img src={user.photoURL} alt="" className="avatar" referrerPolicy="no-referrer" />
                    : <div className="avatar-initials">{(user.displayName || user.email || 'U')[0].toUpperCase()}</div>
                  }
                </button>
                {menuOpen && (
                  <div style={{
                    position: 'absolute', right: 0, top: 40,
                    background: '#fff', border: '0.5px solid rgba(0,0,0,0.12)',
                    borderRadius: 10, boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                    minWidth: 200, zIndex: 200, overflow: 'hidden'
                  }} onClick={() => setMenuOpen(false)}>
                    <div style={{ padding: '10px 14px', borderBottom: '0.5px solid rgba(0,0,0,0.08)' }}>
                      <div className="font-medium text-sm">{user.displayName}</div>
                      <div className="text-sm text-muted" style={{ marginTop: 2 }}>{user.email}</div>
                    </div>
                    <button onClick={() => navigate('/my-events')} className="btn" style={{ width: '100%', borderRadius: 0, border: 'none', justifyContent: 'flex-start', padding: '10px 14px' }}>
                      自分のイベント一覧
                    </button>
                    {isAdmin && (
                      <button onClick={() => navigate('/admin')} className="btn" style={{ width: '100%', borderRadius: 0, border: 'none', justifyContent: 'flex-start', padding: '10px 14px', color: '#185FA5' }}>
                        管理画面
                      </button>
                    )}
                    <button onClick={logout} className="btn" style={{ width: '100%', borderRadius: 0, border: 'none', justifyContent: 'flex-start', padding: '10px 14px', color: '#A32D2D' }}>
                      ログアウト
                    </button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <button className="btn btn-google" onClick={loginWithGoogle}>
              <GoogleIcon />
              Googleでログイン
            </button>
          )}
        </div>
      </div>
    </header>
  );
}

function GoogleIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
    </svg>
  );
}
